'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultExceptionHandler = function defaultExceptionHandler(message, filename, lineno, colno, error) {
  // TODO : handle error here
  console.log(message, filename, lineno, colno, error);
};

var avoidErrorPropagation = function avoidErrorPropagation() {
  var isChromium = window.chrome;
  var vendorName = window.navigator.vendor;
  var isOpera = window.navigator.userAgent.indexOf('OPR') > -1;
  var isIEedge = window.navigator.userAgent.indexOf('Edge') > -1;
  return isChromium !== null && isChromium !== undefined && vendorName === 'Google Inc.' && isOpera === false && isIEedge === false;
};

var getExceptionHandler = function getExceptionHandler(handler) {
  return function (message, filename, lineno, colno, error) {
    handler(message, filename, lineno, colno, error);
    return avoidErrorPropagation();
  };
};

exports.default = function (handler) {
  window.onerror = getExceptionHandler(handler || defaultExceptionHandler);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/util/lib/exceptionHandler.js
 ** module id = 511
 ** module chunks = 0
 **/